import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Card, List, Icon } from "antd";
import { Link } from "react-router-dom";

const LIST_ITEMS = [
    {
        icon: "ordered-list",
        label: "View Company Bank Accounts",
        route: "/app/bank-accounts/company/list",
        key: "/app/bank-accounts/company/list"
    },
    {
        icon: "ordered-list",
        label: "View Lenders Account List",
        route: "/app/bank-accounts/lending-partner/list",
        key: "/app/bank-accounts/lending-partner/list"
    },
    // {
    //     icon: "plus",
    //     label: "Add New Lender",
    //     route: "/app/lenders/onboarding",
    //     key: "/app/lenders/onboarding"
    // }
];


class AccountsActions extends React.Component {
    render() {
        return (
            <Row className={"h-100"} align={"middle"} type={"flex"}>
                <Col span={8} offset={8}>
                    <Card>
                        <List
                            dataSource={LIST_ITEMS}
                            rowKey={"key"}
                            renderItem={({ key, label, route, icon }) => (
                                <List.Item key={key} actions={[<Link key={"link"} to={route}>{">"}</Link>]}>
                                    <List.Item.Meta avatar={<Icon type={icon}/>} title={label}/>
                                </List.Item>
                            )}
                        />
                    </Card>
                </Col>
            </Row>
        );
    }
}

AccountsActions.propTypes = {
    route: PropTypes.object
};

export default AccountsActions;